import { generateColorScheme } from './../../src/utils/colors';

export const primary = {
    50: '#F3F7FF',
    ...generateColorScheme('#005CF7'),
};
